<template>
  <div></div>
</template>

<script>
export default {
  name: 'Support',
  mounted() {
    window.location.href = 'https://maplebolo.feishu.cn/wiki/XI1BwxOJriGskdku51ocyU71n7b';
  }
};
</script>

